import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Privacy.css';

function Privacy() {
  return (
    <div className="privacy-section">
      <Helmet>
        <title>Privacy Policy | Szakacs Visuals Photography</title>
        <meta name="description" content="Privacy policy for Szakacs Visuals photography services. Learn how we handle your personal data and protect your privacy." />
        <meta name="keywords" content="photography privacy policy, data protection, Bristol photographer privacy, photography data handling" />
        <meta property="og:title" content="Privacy Policy | Szakacs Visuals Photography" />
        <meta property="og:description" content="Privacy policy for Szakacs Visuals photography services. Learn how we handle your personal data and protect your privacy." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/privacy" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/privacy" />
      </Helmet>
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <div className="privacy-content">
          <div className="business-info">
            <p>Business Name: Szakacs Visuals</p>
          </div>

          <section>
            <h2>1. Introduction</h2>
            <p>Szakacs Visuals (referred to as "we," "us," or "our") is committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you book or use our photography and videography services.</p>
            <p>By using our services, you agree to the terms of this Privacy Policy. If you have any questions or concerns, please contact us directly.</p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <p>We may collect the following types of personal information:</p>
            <h3>2.1 Information You Provide:</h3>
            <ul>
              <li>Personal details: Name, email address, phone number, and mailing address.</li>
              <li>Payment information: Details required to process payments, such as billing address and transaction details.</li>
              <li>Event details: Information about your event (e.g., date, location, type of event).</li>
            </ul>
            <h3>2.2 Automatically Collected Information:</h3>
            <ul>
              <li>Website usage data: IP address, browser type, and browsing behavior on our website.</li>
              <li>Cookies: Data collected through cookies and similar technologies to enhance your user experience.</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use your personal information for the following purposes:</p>
            <ol>
              <li>Service Delivery: To provide photography and videography services, including managing bookings, creating contracts, and delivering final products.</li>
              <li>Communication: To contact you regarding your booking, event details, or any updates.</li>
              <li>Payment Processing: To process deposits, final payments, and issue invoices.</li>
              <li>Marketing and Promotions: To showcase your photos and videos on our website or social media (with your consent or as outlined in our Terms and Conditions).</li>
              <li>Legal Compliance: To comply with applicable laws, regulations, or legal processes.</li>
            </ol>
          </section>

          <section>
            <h2>4. Sharing Your Information</h2>
            <p>We may share your personal information in the following circumstances:</p>
            <ol>
              <li>With Service Providers: Third-party companies that assist in providing our services, such as payment processors or delivery services.</li>
              <li>Legal Requirements: When required by law, such as to comply with legal obligations or respond to lawful requests.</li>
              <li>Business Use: To promote our services using images or videos from your event (in line with our Terms and Conditions).</li>
            </ol>
          </section>

          <section>
            <h2>5. Data Retention</h2>
            <p>We retain your personal information for as long as necessary to:</p>
            <ul>
              <li>Provide our services.</li>
              <li>Comply with legal obligations.</li>
              <li>Resolve disputes.</li>
              <li>Enforce our agreements.</li>
            </ul>
          </section>

          <section>
            <h2>6. Your Rights</h2>
            <p>You have the following rights regarding your personal information:</p>
            <ol>
              <li>Access: Request a copy of the personal information we hold about you.</li>
              <li>Correction: Request corrections to any inaccurate or incomplete information.</li>
              <li>Deletion: Request the deletion of your personal information, subject to legal and contractual obligations.</li>
              <li>Data Portability: Request a copy of your data in a machine-readable format.</li>
              <li>Withdraw Consent: Withdraw your consent for specific uses of your information, such as marketing.</li>
            </ol>
            <p>To exercise these rights, please contact us directly.</p>
          </section>

          <section>
            <h2>7. Security Measures</h2>
            <p>We take appropriate technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. These measures include:</p>
            <ul>
              <li>Secure payment processing systems.</li>
              <li>Encrypted communications.</li>
              <li>Access controls and regular system audits.</li>
            </ul>
          </section>

          <section>
            <h2>8. Cookies and Tracking Technologies</h2>
            <p>We use cookies to enhance your browsing experience on our website. You can manage your cookie preferences through your browser settings.</p>
          </section>

          <section>
            <h2>9. Updates to This Privacy Policy</h2>
            <p>We may update this Privacy Policy from time to time to reflect changes in our practices or for legal and regulatory reasons. The latest version will always be available on our website.</p>
          </section>

          <section>
            <h2>10. Contact Us</h2>
            <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:</p>
            <div className="contact-info">
                <p>Szakacs Visuals</p>
              <p>Email: szakacs.visuals@gmail.com</p>
              <p>Phone: 00447547546171</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacy; 